import React from 'react';
import { FaIdCard, FaUser, FaMapMarkerAlt, FaLayerGroup, FaCheck, FaTimes } from 'react-icons/fa';
import styles from '../../../styles/Cadastral.module.css';

function Block({ title, icon: Icon, children }) {
  return (
    <div className={styles.block}>
      <div className={styles.blockTitle}>
        <span className={styles.btIco}><Icon size={13} /></span>
        {title}
      </div>
      {children}
    </div>
  );
}

function Dl({ items, singleCol = false }) {
  return (
    <dl className={`${styles.dl} ${singleCol ? styles.one : ''}`}>
      {items.map(([label, val, className = ''], index) => (
        <div key={index}>
          <dt>{label}</dt>
          <dd className={styles[className] || className}>
            {val || <span className={styles.voidText}>Sin dato en el padrón</span>}
          </dd>
        </div>
      ))}
    </dl>
  );
}

export default function GeneralTab({ record, file }) {
  const registry = file.registry;
  const cadastralKey = record.propertyKey;

  const identificationDetails = [
    ['Clave catastral', cadastralKey, 'mono'],
    ['Cuenta predial', registry.account, 'mono'],
    ['Sector catastral', registry.sector, 'mono'],
    ['Zona catastral', registry.zone],
    ['Manzana', registry.block, 'mono'],
    ['Lote / predio', registry.lot, 'mono'],
    ['Clasificación del predio', record.classification],
    ['Régimen de propiedad', registry.regime],
    ['Uso de suelo', registry.landUse],
    ['Año de construcción', registry.constructionYear || null],
    ['Fecha de alta en el padrón', registry.registrationDate, 'num'],
    ['Última actualización catastral', registry.lastUpdateDate, 'num']
  ];

  const keyBreakdown = [
    { segment: 'Municipio', digits: cadastralKey.slice(0, 2), description: 'Querétaro (clave 14)' },
    { segment: 'Región', digits: cadastralKey.slice(2, 4), description: 'Región catastral' },
    { segment: 'Sector', digits: cadastralKey.slice(4, 7), description: 'Sector catastral' },
    { segment: 'Manzana', digits: cadastralKey.slice(7, 9), description: 'Manzana catastral' },
    { segment: 'Predio', digits: cadastralKey.slice(9, 12), description: 'Número de predio' },
    { segment: 'Unidad', digits: cadastralKey.slice(12, 15), description: 'Unidad privativa / condominal' }
  ];

  const ownerDetails = [
    ['Propietario(s)', record.ownerName],
    ['Tipo de persona', record.entityType === 'M' ? 'Persona moral' : 'Persona física'],
    ['R.F.C.', record.rfc, 'mono'],
    ['Domicilio fiscal', record.fiscalAddress]
  ];

  const locationDetails = [
    ['Ubicación del predio', record.address],
    ['Asentamiento humano', record.neighborhood],
    ['Delegación municipal', record.delegation],
    ['Municipio / Estado', 'Querétaro, Querétaro'],
    ['Latitud', record.latitude ? record.latitude.toFixed(8) : null, 'mono'],
    ['Longitud', record.longitude ? record.longitude.toFixed(8) : null, 'mono']
  ];

  return (
    <div className={styles.tabContentFade}>
      <Block title="Identificación del predio" icon={FaIdCard}>
        <Dl items={identificationDetails} />
      </Block>

      <Block title="Estructura de la clave catastral" icon={FaLayerGroup}>
        <div className={styles.tblWrap}>
          <table className={styles.tbl}>
            <thead>
              <tr>
                <th>Segmento</th>
                <th className={styles.c}>Dígitos</th>
                <th>Significado</th>
              </tr>
            </thead>
            <tbody>
              {keyBreakdown.map((item, index) => (
                <tr key={index}>
                  <td>{item.segment}</td>
                  <td className={styles.c}><span className={styles.typePill}>{item.digits}</span></td>
                  <td>{item.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Block>

      <Block title="Datos del propietario" icon={FaUser}>
        <Dl items={ownerDetails} singleCol />
      </Block>

      <Block title="Ubicación" icon={FaMapMarkerAlt}>
        <Dl items={locationDetails} />
      </Block>

      <Block title="Servicios municipales" icon={FaLayerGroup}>
        <div className={styles.services}>
          {Object.entries(file.services).map(([serviceName, isAvailable]) => (
            <div key={serviceName} className={`${styles.svc} ${isAvailable ? styles.yes : styles.no}`}>
              {isAvailable ? <FaCheck size={12} /> : <FaTimes size={12} />}
              <span>{serviceName}</span>
            </div>
          ))}
        </div>
      </Block>
    </div>
  );
}